import React ,{useEffect} from 'react'
const NotFound = () => {
   
  return (
    <div className='page-min-height d-flex justify-content-center align-items-center'>
        <h1>Page Not Found</h1>
        </div>
  )
}

export default NotFound